var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-0"},[_c('v-col',{staticClass:"pt-0 px-0",attrs:{"cols":"5","xl":"4"}},[_c('WizardSidebar')],1),_c('v-col',{staticClass:"pt-0 pl-0",attrs:{"cols":"7","xl":"8"}},[_c('WizardContentMio')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }